import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useLocation } from 'react-router-dom'

import { URL_STATE_PREFIX } from 'features/scoped_url_state'

export const usePageHasUserGuide = () => {
  const { pathname, search } = useLocation()
  const isMobile = useDeviceType('isPhone')
  const searchParams = new URLSearchParams(search)

  // Do not show if the global right rail is open.
  if (URL_STATE_PREFIX.RIGHT_RAIL in searchParams) return false

  if (pathname === '/organization/invitations/agreement') return false
  if (pathname.startsWith('/app/workflows') || pathname.startsWith('/app/automations')) return false
  if (pathname.startsWith('/app/routing')) return false
  if (pathname.startsWith('/app/admin/users')) return false
  if (pathname.startsWith('/app/scheduled_events')) return false
  if (pathname.match(/\/app\/users\/\w+\/workflow/)) return false
  if (pathname.startsWith('/app/landing_pages/new')) return false
  if (pathname.match(/\/app\/landing_pages\/[a-zA-Z0-9-]+\/edit/)) return false
  if (
    (
      pathname.match(/\/event_types\/\d+\/edit/)
      || pathname.match(/\/organization_event_types\/\d+\/edit/)
      || pathname.match(/\/event_types\/new/)
      || pathname.match(/\/organization_event_types\/new/)
    )
    && isMobile
  ) return false
  if (pathname === '/app/organization/invitations/new' || pathname === '/app/admin/invitations/new') return false
  if (pathname.includes('/app/meetings/') && (searchParams.get('filter_open') === 'true') && isMobile) return false

  return true
}
